/** Recherche + filtres de liste. */
import "../clients/clientListBar.css";
import { SearchClear } from "../../components/SearchClear";

export type ListFilter = { id: string; label: string };

type QuotesListBarProps = {
  q: string;
  onQ: (v: string) => void;
  count?: number;
  unit?: string;
  filters?: ListFilter[];
  filter?: string;
  onFilter?: (id: string) => void;
};

export function QuotesListBar({ q, onQ, count, unit = "devis", filters, filter, onFilter }: QuotesListBarProps) {
  return (
    <>
    <div className="fx-listbar">
      <label className="fx-listbar__search">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="10.5" cy="10.5" r="6.2" stroke="currentColor" strokeWidth="1.7" />
          <path d="M15.2 15.2 20 20" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
        </svg>
        <input
          className="fx-listbar__input"
          name="q"
          value={q}
          placeholder="N°, client, montant, statut ou empreinte"
          autoComplete="off"
          aria-label={unit === "factures" ? "Rechercher une facture" : "Rechercher un devis"}
          onChange={(e) => onQ(e.target.value)}
        />
        <SearchClear value={q} onClear={() => onQ("")} />
      </label>
      {typeof count === "number" ? (
        <span className="fx-listbar__count">
          {count} {unit}
        </span>
      ) : null}
    </div>
    {filters && filters.length > 0 ? (
      <div className="fx-filters" role="group" aria-label="Filtrer">
        {filters.map((f) => (
          <button
            key={f.id}
            type="button"
            className={filter === f.id ? "is-on" : ""}
            aria-pressed={filter === f.id}
            onClick={() => onFilter?.(f.id)}
          >
            {f.label}
          </button>
        ))}
      </div>
    ) : null}
    </>
  );
}
